import getStore from '../store/store';
import { userDate } from 'owa-datetime/lib/userDate';
import { mutator } from 'satcheljs';
import setStartTime from '../../actions/setStartTime';
import getEndDateAfterModifications from '../../utils/getEndDateAfterModifications';

/**
 * Function to mutate the start time.
 */
export default mutator(setStartTime, ({ dateTime }) => {
    let optionState = getStore().currentState;
    let initialState = getStore().initialState;
    if (optionState.startDate) {
        let curStart = optionState.startDate;

        let startHours = dateTime.getHours();
        let startMinutes = dateTime.getMinutes();
        let startYear = curStart.getFullYear();
        let startMonth = curStart.getMonth();
        let startDate = curStart.getDate();
        // Set new start
        let newStart = userDate(startYear, startMonth, startDate, startHours, startMinutes);
        optionState.startDate = newStart;
    } else {
        let initialStart = initialState.startDate;
        let startHours = dateTime.getHours();
        let startMinutes = dateTime.getMinutes();
        let startYear = initialStart.getFullYear();
        let startMonth = initialStart.getMonth();
        let startDate = initialStart.getDate();
        // Set new start
        let newStart = userDate(startYear, startMonth, startDate, startHours, startMinutes);
        optionState.startDate = newStart;
    }
    optionState.endDate = getEndDateAfterModifications();
});
